import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import {
  Stack,
  Container,
  CircularProgress,
  Card,
  CardContent,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

import Breadcrumbs from 'components/Breadcrumbs';
import TermsForm from 'sections/settings/TermsForm';

import { getTerms } from 'services/requests/terms';
import { toast } from 'utils';

export default function Terms() {
  const navigate = useNavigate()

  const [data, setData] = useState(null)
  const [loadingData, setLoadingData] = useState(true)

  const getData = () => {
    getTerms({ type: 'terms_of_use' })
      .then((res) => setData(res))
      .catch((err) => {
        toast(err, 'error')
        navigate('/', { replace: true })
      })
      .finally(() => setLoadingData(false));
  }

  useEffect(() => {
    getData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Helmet>
        <title>Termos de Uso | { process.env.REACT_APP_PROJECT_NAME }</title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Breadcrumbs
            items={[
              { label: 'Termos de Uso' }
            ]}
          />
        </Stack>

        <Stack>
          {
            loadingData ? (
              <Stack spacing={3} alignItems="center">
                <CircularProgress size={80} sx={{ my: 12 }} />
              </Stack>
            ) : data ? (
              <Card>
                <CardContent mt={2}>
                  <TermsForm
                    defaultValues={data}
                    type="terms_of_use"
                  />
                </CardContent>
              </Card>
            ) : null
          }
        </Stack>
      </Container>
    </>
  )
}
